<template>
  <div class="basic-block block-fortune-result" :style="styles">
    <div class="content-wrap">
      <div class="block-fortune-result__inner">
        <p class="block-fortune-result__lead">{{ targetInfo.fortuneResult.lead }}{{ resultData.text1 }}</p>
        <img :src="resultData.image1" class="block-fortune-result__img" :alt="resultData.text1">
        <p class="block-fortune-result__type">{{ targetInfo.fortuneResult.type }}</p>
        <p class="block-fortune-result__text" v-html="resultData.text2"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockFortuneResult',
  props: {
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    resultData: Object,
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    }
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.block-fortune-result {
  background: #FFEDFA;
  padding-bottom: 24px;
  &__inner {
    margin: 0 20px;
    padding: 24px 0 0;
    background: #fff;
  }
  &__lead,
  &__type {
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    color: $l_col_keycolor;
    margin: 0 0 20px;
  }
  &__img {
    max-width: 100%;
    margin: 0 auto 20px;
    vertical-align: middle;
  }
  &__text {
    font-size: 14px;
    line-height: 24px;
    text-align: justify;
    margin: 0 20px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/ottimo/blocks/BlockFortuneResult.vue